module.exports = __webpack_public_path__ + "img/LMTPlaceholder.3d0321da.svg";